import { SubmissionNS, SubmissionSchema } from "@smart/bridge-types-basic";
import { buildTableDef } from "@smart/itops-constructs-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const submissionGuard = wrapSchema(SubmissionSchema);

export const SubmissionDef = buildTableDef(
  {
    namespace: SubmissionNS,
    guard: submissionGuard,
    keyFields: ["uri"],
    keySchema: { uri: "string" },
    ttlField: "deletedAtSec",
  } as const,
  {
    byForm: {
      indexName: "byForm",
      keyFields: ["formUri", "updatedAt"],
      keySchema: { formUri: "string", updatedAt: "string" },
    },
    byHash: {
      indexName: "byHash",
      keyFields: ["hashUri", "updatedAt"],
      keySchema: { hashUri: "string", updatedAt: "string" },
    },
    byTeam: {
      indexName: "byTeam",
      keyFields: ["teamUri", "updatedAt"],
      keySchema: { teamUri: "string", updatedAt: "string" },
    },
    byTeamCreated: {
      indexName: "byTeamCreated",
      keyFields: ["teamUri", "createdAt"],
      keySchema: { teamUri: "string", createdAt: "string" },
    },
    byMatter: {
      indexName: "byMatter",
      keyFields: ["matterId", "formUri"],
      keySchema: { matterId: "string", formUri: "string" },
    },
    byMatterStatus: {
      indexName: "byMatterStatus",
      keyFields: ["matterId", "status"],
      keySchema: { matterId: "string", status: "string" },
    },
    byRecipientEmail: {
      indexName: "byRecipientEmail",
      keyFields: ["recipientEmail", "teamUri"],
      keySchema: { recipientEmail: "string", teamUri: "string" },
    },
    byTeamStatusCreated: {
      indexName: "byTeamStatusCreated",
      keyFields: ["teamStatus", "createdAt"],
      keySchema: { teamStatus: "string", createdAt: "string" },
    },
    byTeamStatusUpdated: {
      indexName: "byTeamStatusUpdated",
      keyFields: ["teamStatus", "updatedAt"],
      keySchema: { teamStatus: "string", updatedAt: "string" },
    },
    byTeamStatusCompleted: {
      indexName: "byTeamStatusCompleted",
      keyFields: ["teamStatus", "completedAt"],
      keySchema: { teamStatus: "string", completedAt: "string" },
    },
  } as const,
);
